import { useEffect, useState } from "react";
import {
  TextField,
  Box,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";

import CustomInput from "../../components/CustomInput/CustomInput.component";
import WalletHeading from "./WalletHeading/WalletHeading.component";

import assetDashLogo from "../../assets/images/logo/AssetDashLogo.png";

import { callBackendAPI } from "../../helpers/api";

import walletValidators from "../../helpers/walletValidation";
import {
  createProviderLinkOnClose,
  createProviderLinkOnFailure,
  createProviderLinkOnSuccess,
} from "../../helpers/webViewCallback";

function ManualProvider(props) {
  const { providerData, mode, walletId } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [walletAddress, setWalletAddres] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    if (mode === "fix") {
      fixWallet();
    }
  }, [mode]);

  useEffect(() => {
    window.analytics.track("provider_link_manual_page_view", {
      providerData,
      walletId,
    });
  }, []);
  // const walletName =
  //   institutionId.charAt(0).toUpperCase() + institutionId.slice(1);
  const {
    id: providerId,
    name,
    wallet_type,
    display_name,
    logo_url,
  } = providerData || {};

  console.log(providerData, "providerData");
  const handleSubmit = async () => {
    window.analytics.track(
      "provider_link_manual_wallet_submit_button_clicked",
      {
        target: "providerLink",
        providerData,
        walletId,
      }
    );
    if (walletAddress === "") {
      setErrorMsg("Wallet address is required");
      return;
    }

    const resp = await walletValidators[name](walletAddress);
    const isValid = resp.status;
    if (!isValid) {
      setErrorMsg(`Not a valid ${name} address`);
      return;
    }
    setErrorMsg("");
    setIsLoading(true);

    const responseJson = await callBackendAPI({
      path: "/provider_link/create_link",
      method: "POST",
      body: {
        link_type: wallet_type,
        provider_id: providerId,
        public_token: "",
        subtype: "",
        address: resp.data ? resp.data : walletAddress,
        access_token: "",
        name: resp.data ? walletAddress : undefined,
      },
    });
    if (responseJson) {
      console.log(responseJson);
      if (responseJson.detail) {
        // setErrorMsg(responseJson.detail);
        window.analytics.track("provider_link_failure", {
          source: "manual_wallet",
          target: "providerLink",
          message: responseJson?.detail,
          providerData,
          walletId,
        });
        createProviderLinkOnFailure(responseJson.detail);
      }
      setIsLoading(false);
      if (responseJson && responseJson.user_wallet_id) {
        window.analytics.track("provider_link_success", {
          source: "manual_wallet",
          target: "providerLink",
          walletId: responseJson.user_wallet_id,
          providerData,
          walletId,
        });
        createProviderLinkOnSuccess({
          message: `${name} wallet linked successfully`,
          walletId: responseJson.user_wallet_id,
        });
      }
    }
  };

  const handleInputChange = async (e) => {
    const val = e.target.value;
    setWalletAddres(val);
  };

  const fixWallet = async () => {
    try {
      const resp = await callBackendAPI({
        path: `/provider_link/fix_link`,
        method: "POST",
        body: {
          link_type: providerData.wallet_type,
          link_id: walletId,
        },
      });

      window.analytics.track("provider_link_fix_success", {
        source: "manual_wallet",
        target: "providerLink",
        providerData,
        walletId,
      });

      return setTimeout(() => {
        createProviderLinkOnSuccess({
          message: `${name} wallet synced successfully`,
        });
      }, 1500);
    } catch (error) {
      console.log(error);
      createProviderLinkOnFailure({
        message: "Something went wrong please try again",
      });
      window.analytics.track("provider_link_fix_failure", {
        source: "manual_wallet",
        target: "providerLink",
        providerData,
        walletId,
      });
    }
  };

  return (
    <Box
      style={{ height: "90vh" }}
      p={3}
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
    >
      {/* <h1 className="anim--slide-down ">{`${walletName} Wallet`}</h1> */}
      <Box
        style={{ position: "fixed", left: "0px", top: "40px", width: "100%" }}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <img src={assetDashLogo} alt="logo" className="logo-1" />{" "}
        <Box ml={1}>
          <Typography variant="h6">AssetDash</Typography>
        </Box>
      </Box>
      <Box className="anim--slide-down " mb={2} mt={8}>
        <WalletHeading
          name={name}
          displayName={display_name}
          logoUrl={logo_url}
        />
      </Box>
      {mode === "fix" ? (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          className="anim--slide-up anim--delay-1"
        >
          <Box mr={2}>
            <CircularProgress size={25} />
          </Box>
          <Box>
            <Typography>We are re syncing your {name} wallet</Typography>
          </Box>
        </Box>
      ) : (
        <Box style={{ maxWidth: "500px", width: "100%" }}>
          <Box mb={2} className="anim--slide-down anim--delay-1">
            <CustomInput
              placeholder="Enter wallet address"
              value={walletAddress}
              onChange={handleInputChange}
              errorMsg={errorMsg}
            />
          </Box>
          <Box>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              className="anim--slide-up anim--delay-2"
              endIcon={isLoading && <CircularProgress size={25} />}
              disabled={isLoading}
              onClick={handleSubmit}
            >
              Confirm
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default ManualProvider;
